import { SailsTariffOverviewStorage } from 'Container/App/interface';
import { getDeviceIdFromSails } from '@vfde-sails/storage';

/**
 * Get device ID from storage
 */
export const getDeviceId = (storage: SailsTariffOverviewStorage | null): string | null =>
    getDeviceIdFromSails(storage || {} as SailsTariffOverviewStorage) as string || null;
